import React, { useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './sweetAlert.css'

const MySwal = withReactContent(Swal);

export const triggerDynamicAlert = (title, text, icon, confirmText) => {
    MySwal.fire({
        title: <p>{title || 'Default Title'}</p>,
        text: text || '',
        icon: icon || 'info',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: confirmText || 'Yes',    
        cancelButtonText: 'Cancel',
        customClass: {
            confirmButton: 'btn btn-danger ms-2 btn-lg',  // Red button for "Yes"
            cancelButton: 'btn btn-secondary btn-lg',  // Gray button for "Cancel"
        },
        buttonsStyling: false,  // Disable default styles so we can apply Bootstrap styles
    }).then((result) => {
        // console.log(result);
        // API call
    });
};

export const categoryDetailsAlert = (title, data) => {
    // console.log('data in alert ', data);
    MySwal.fire({
        title: <p>{title || 'Category Details'}</p>,
        showCloseButton: true,
        showConfirmButton: false,
        html: (
            <table className='table table-responsive' style={{ width: '100%', textAlign: 'center' }}>
                <tr className='my-3 py-3'>
                    <td>Category Name</td>
                    <td>:</td>
                    <td>{data.categoryName}</td>
                </tr>
                <tr className='my-3 py-3'>
                    <td>Category Path</td>
                    <td>:</td>
                    <td>{data.categoryDetails}</td>
                </tr>
                <tr>
                    <td>Category Thumnail</td>
                    <td>:</td>
                    <td><img src={"/images/noimage.png"} style={{ 'height': '100px', width: '100%', maxWidth: '100%' }} /></td>
                    {/* <td><img src={data.categoryImage} /></td> */}
                </tr>
                <tr>
                    <td>Category Banner</td>
                    <td>:</td>
                    <td><img src={"/images/noimage.png"} style={{ 'height': '100px', width: '100%', maxWidth: '100%' }} /></td>
                    {/* <td><img src={data.bannerImage} /></td> */}
                </tr>
                <tr>
                    <td>Content</td>
                    <td>:</td>
                    <td>{data.content}</td>
                </tr>
                <tr>
                    <td>Category Status</td>
                    <td>:</td>
                    <td className={data.status === 1 ? 'text-success' : 'text-danger'}>
                        {data.status === 1 ? 'Active' : 'Inactive'}
                    </td>
                </tr>
            </table>
        )
    })
}

export const triggerDynamicAlerts = (title, text, icon, confirmText) => {
  // return the promise so callers can await it
  return MySwal.fire({
    title: <p>{title || 'Default Title'}</p>,
    text: text || '',
    icon: icon || 'info',
    reverseButtons: true,
    showCancelButton: true,
    confirmButtonText: confirmText || 'Yes',
    cancelButtonText: 'Cancel',
    customClass: {
      confirmButton: 'btn btn-danger ms-2 btn-lg',
      cancelButton: 'btn btn-secondary btn-lg',
    },
    buttonsStyling: false,
  });
};

const DynamicSweetAlert = () => {
    return (
        <div className="container mt-5">
            <h2>Dynamic SweetAlert Example</h2>

            <button
                className="btn btn-primary"
                onClick={() => triggerDynamicAlert('Success!', 'This is a success alert!', 'success')}
            >
                Show Success Alert
            </button>

            <button
                className="btn btn-danger ml-2"
                onClick={() => triggerDynamicAlert('Error!', 'Something went wrong...', 'error')}
            >
                Show Error Alert
            </button>

            <button
                className="btn btn-warning ml-2"
                onClick={() => triggerDynamicAlert('Warning!', 'Proceed with caution!', 'warning')}
            >
                Show Warning Alert
            </button>

            <button
                className="btn btn-info ml-2"
                onClick={() => triggerDynamicAlert('Info!', 'This is an information alert.', 'info')}
            >
                Show Info Alert
            </button>
        </div>
    );
};

export default DynamicSweetAlert;
